export const locale = {
    lang: 'en',
    data: {
        nav: {
            dashboards: 'Dashboard',
            customer: 'Customer',
            profiles: 'Profiles',
            trading_accounts: 'Trading Accounts',
            trading_account_request: 'Requests',
            accounts: 'Accounts',
            groups: 'Groups',
            fund_management: 'Fund Management',
            deposits: 'Deposits',
            transfer: 'Transfer',
            b2b_transfer: 'B2B Transfer',
            withdrawal: 'Withdrawal',
            funding_methods: 'Funding Methods',
            requests: 'Requests',
            leverage: 'Leverage',
            others: 'Others',
            report: 'Report',
            symbol: 'Symbol',
            trade: 'Trade',
            sales: 'Sales',
            monitoring: 'Monitoring',
            special_features: 'Bulk Operations',
            settings: 'Settings',
            credit_cards: 'Credit Cards',
            union_pay_cards: 'Union Pay Cards',
            bank_account: 'Bank Accounts',
            black_lists: 'Black Lists',
            payouts: 'Payouts',
            watchdog: 'Watchdog',
            repair: 'Repair',
            jarvis: 'Jarvis',
            rpn: 'RPN',
            payquay: 'PayQuay',
            t365: 'T365',
            fingerprint: 'Fingerprint',
            request_fingerprint: 'Request List',
            watchlist: 'Watchlist',
            ip: 'IP',
            notifications: 'Notifications',
            reports: 'Reports',
            operations: 'Operations',
            funds: 'Funds',
            credit_to_balance: 'Credit to Balance',
            good_will: 'Good will',
            swaps: 'Swaps',
            rewards: 'Rewards',
            custom: 'Custom',
            bpay: 'BPay',
            deposit_repair: 'Deposit Repair',
            union_pay: 'Union Pay',
            deposit_peek_config: 'Deposit Peek Config',
            zpay: 'Zpay2 - Union Pay',
            contacts: 'Contacts',
            users: 'Users',
            fasapay: 'Fasapay',
            poli: 'Poli',
            skrill: 'Skrills',
            payment_platform: 'Payment Platforms',
            payment_gateway: 'Payment Gateways',
            trading_account_groups: 'Trading Account Groups',
            user_role: 'Users Role',
            identity_document: 'Documents',
            upgrade: 'Upgrade Account',
            internal_broker: 'IBs',
            partners: 'Partners',
            ib_credit_transfer: 'IB Credit transfer',
            xpay_thai: 'XPay (Thai)',
            xpay: 'Xpay',
            document_management: 'Document Management',
            lookup_management: 'Lookup Management',
            promotions: 'Promotions',
            country_licences: 'Country Licences',
            compliance: 'Compliance',
            novation_requests: 'Novation Requests',
            payout_sheets: 'Payout Sheets',
            bulk_transfer: 'Bulk Transfer'
        },
        common: {
            confirm_question: 'Are you sure?',
            delete_warning: 'This item will be deleted.',
            message_sync: 'This item will be synchronized.',
            notification: {
                error: 'Error',
                save_success: 'Your data has been successfully saved.',
                sync_success: 'Your data has been successfully synchronized.',
                session_timeout: 'Your session has expired. Please login again',
                success: 'Successful',
                upload_file_success: 'Your file has been uploaded successfully',
                upload_file_fail: 'Your file has been uploaded unsuccessfully',
                error_occur: 'There is an error occurred'
            },
            validation: {
                is_required: 'is required!',
                must_accepted: 'must be accepted.',
                invalid_json: 'is invalid JSON.',
                password: 'Password is not strong enough',
                credit_card_last_digits: 'Has to be 4 digits',
                password_incorrect: 'Password is incorrect',
                email_invalid: 'Email format invalid'
            },
            label: {
                action: 'Action',
                bkac: 'Bank Account',
                code: 'Code',
                show: 'Show',
                hide: 'Hide',
                date: 'Date',
                dropdown_select: '-- Select --',
                select_all: 'Select All',
                enabled: 'Enabled',
                disabled: 'Disabled',
                email: 'Email',
                created: 'Created',
                ip_address: 'IP Address',
                platform_login: 'Platform Login',
                password: 'Password',
                download: 'Download',
                no_matching_found: 'No matching found',
                name: 'Name',
                currency_lookup: 'Currency',
                searchable_hint: 'Please enter 3 characters at least to search',
                search_country_hint: 'Please enter country to search',
                confirmed: 'Confirmed',
                un_confirmed: 'Un-confirmed',
                batch: 'Batch',
                read_only_true: 'Yes',
                read_only_false: 'No',
                copied: 'Copied!',
                status: 'Status',
                request_text: 'Request Text',
                updated: 'Updated',
                state: 'State',
                show_refunded: 'Show Refunded',
                withdraw_amount: 'Withdraw Amount',
                payment_gateway: 'Payment Gateway',
                created_date: 'Created Date',
                from: 'From',
                to: 'To'
            },
            go_to_edit: 'Go to Edit page',
            error: {
                invalid_csv_file: 'Invalid CSV file',
            },
            records_not_found: 'Records not found',
            search: 'Use search or sort to fetch some data',
            message: {
                at_least_3_chars: 'Please input as least 3 characters ...'
            }
        },
        button_name: {
            create: 'Create',
            create_and_add: 'Create and add another',
            create_and_return: 'Create and return to list',
            update: 'Update',
            update_and_close: 'Update and close',
            delete: 'Delete',
            delete_selected: 'Delete Selected',
            view_detail: 'View Detail',
            edit: 'Edit',
            save: 'Save',
            sync: 'Sync',
            save_and_add_one_more: 'Save and add one more',
            save_then_return: 'Save and return to list',
            update_then_return: 'Update and return to list',
            deny: 'Deny',
            approve: 'Approve',
            log_out: 'Logout',
            reset: 'Reset',
            search: 'Search',
            preview: 'Preview',
            view: 'View',
            add_new: 'Add New {{section_name}}',
            export: 'Export',
            export_all: 'Export All',
            export_selected: 'Export Selected',
            cancel: 'Cancel',
            link: 'Link',
            continue: 'Continue',
            continue_then_return: 'Continue and return to list'
        },
        login: {
            title: 'LOGIN TO ADMIN SYSTEM',
            username: 'Username',
            rememberme: 'Remember Me',
            loginbtn: 'Login',
            urequired: 'Username is required',
            prequired: 'Password is required',
            forgot_password: 'Forgotten Password?',
            reset_password_successful: 'The password has been reset successfully.',
            entity: {
                label: 'Entity',
                eig_asic: 'Eightcap Pty Ltd.',
                eig_cysec: 'Eightcap EU Ltd',
                eig_fca: 'Eightcap Ltd UK',
                eig_scb: 'Eightcap Global Ltd. (SCB)',
                eig_svg: 'Eightcap Global Ltd. (SVG)',
                eig_vfsc: 'Eightcap Global Ltd.',
                blu_asic: 'Blueberry Markets',
                blu_fca: 'Eightcap Ltd UK (Blueberry Markets)',
                blu_scb: 'Eightcap Global Ltd (Blueberry Markets - SCB)',
                blu_svg: 'Eightcap Global Ltd (Blueberry Markets - SVG)',
                blu_vfsc: 'Eightcap Global Ltd (Blueberry Markets)',
                fcs_asic: 'FocusMarkets',
                fcs_vfsc: 'FocusMarkets Global (FCS_VFSC)',
                pat_asic: 'Place A Trade Pty Ltd',
                pat_vfsc: 'Focus Markets LLC trading as Place a Trade',
            },
        },
        forgot_password: {
            check_email: 'CHECK EMAIL',
            thank_you: 'Thank you',
            noticed:
                'An email has been sent to {{emailRequest}}. It contains a link you must click to reset your password.',
            recovery_password: 'RECOVERY YOUR PASSWORD',
            email_required: 'Email is required',
            validate_email: 'Please enter a valid email address',
            send_link: 'SEND RESET LINK',
            go_login: 'Go back to login',
            email: 'Email',
        },
        reset_password: {
            reset_your_pass: 'RESET YOUR PASSWORD',
            email: 'Email',
            email_required: 'Email is required',
            validate_email: 'Please enter a valid email address',
            password_required: 'Password is required',
            password_confirm: 'Password (Confirm)',
            password_confirm_required: 'Password confirmation is required',
            password_confirm_match: 'Passwords must match',
            reset_my_pass: 'RESET MY PASSWORD',
            go_login: 'Go back to login',
        },
        lock: {
            title: 'YOUR SESSION IS LOCKED',
            content: 'Due to inactivity, your session is locked. Enter your password to continue.',
            unlock: 'UNLOCK',
        },
        account: {
            ib: 'Introducing Broker',
            entity_types: 'Entity Types',
            entity_types_required: 'Entity Types is required !',
            owner_id: 'Owner ID',
            owner_id_required: 'Owner ID is required !',
            name_required: 'Name is required !',
            tranding_acc_limit: 'Trading Account Limit',
            tranding_acc_limit_required: 'Trading Account Limit is required!',
            tranding_acc_limit_number: 'Trading Account Limit is a number !',
            tranding_acc_limit_trading_account: 'Trading Account must in the specified inclusive range of 1 to 6 !',
            risk_level: 'Risk Level',
            risk_level_required: 'Risk Level is required !',
            account_type: 'Account Type',
            acc_purpose: 'Account purpose',
            min_deposit_limit: 'Min deposit limit',
            max_deposit_limit: 'Max deposit limit',
            acc_purpose_required: 'Account purpose is required !',
            approx_tradding_funds: 'Approx trading funds',
            approx_tradding_funds_required: 'Approx trading funds is required !',
            source_deadling_funds: 'Source of dealing funds',
            source_deadling_funds_required: 'Source of dealing funds is required !',
            trading_experience: 'Trading experience',
            trading_experience_required: 'Trading experience is required !',
            previous_traded_products: 'Previous traded products',
            previous_traded_products_required: 'Previous traded products is required !',
            cxd: 'Cxd',
            complilance: 'Compliance',
            legal_accepted: 'Legal Accepted',
            legal_accepted_required: 'Legal Accepted is required !',
            legal_accepted_true: 'Legal Accepted must be checked !',
            legal_accepted_date: 'Legal accepted date',
            legal_accepted_date_required: 'Legal accepted date is required !',
            acknowledge_risks: 'Acknowledge risks',
            acknowledge_risks_true: 'Acknowledge risks must be checked !',
            acknowledge_risks_date: 'Acknowledge risks date',
            acknowledge_risks_date_required: 'Acknowledge risks date is required !',
            tax_compliance_place_of_birth: 'Tax compliance place of birth',
            tax_compliance_place_of_birth_required: 'Tax compliance place of birth is required !',
            tax_compliance_country_of_tax_residence: 'Tax compliance country of tax residence',
            tax_compliance_country_of_tax_residence_required: 'Tax compliance country of tax residence is required !',
            tax_compliance_identification_number: 'Tax compliance identification number',
            tax_compliance_identification_number_required: 'Tax compliance identification number is required !',
            tax_compliance_reason_not_provided: 'Tax compliance reason not provided',
            tax_compliance_reason_not_provided_required: 'Tax compliance reason not provided is required !',
            tax_compliance_date_added: 'Tax compliance date added',
            tax_compliance_date_added_required: 'Tax compliance date added is required !',
            referral_agreement_accepted: 'Referral agreement accepted',
            referal_agreement_accepted_true: 'Referral agreement accepted must be checked !',
            referral_agreement_accepted_date: 'Referral agreement accepted date',
            referal_agreement_accepted_date_required: 'Referral agreement accepted date is required !',
            referral_remuneration_accepted: 'Referral remuneration accepted',
            referal_renuneration_accepted_true: 'Referral remuneration accepted must be checked !',
            referral_remuneration_accepted_date: 'Referral remuneration accepted date',
            referal_renuneration_accepted_date_required: 'Referral remuneration accepted date is required !',
            privacy_policy_accepted: 'Privacy policy accepted',
            privacy_policy_accepted_true: 'Privacy policy accepted must be checked !',
            privacy_policy_accepted_date: 'Privacy policy accepted date',
            privacy_policy_accepted_date_required: 'Privacy policy accepted date is required !',
            tenant: 'Tenant',
            from_tenant: 'From Tenant',
            to_tenant: 'To Tenant',
            tenant_required: 'Tenant is required!',
            label: {
                account_id: 'ID',
                entity_type_lookup: 'Entity Type',
                account_status: 'Status',
                trading_account_limit: 'Limit',
                account: 'Account'
            },
            created: 'Created',
            redirect_link: 'Redirect Link',
            redirect_link_enabled: 'Redirect Link Enabled',
            total_deposit: 'Total Deposit',
            total_withdraw: 'Total Withdraw',
            total_trading_volume: 'Total Trading Volume',
            nominated_contact_role: 'Nominated Contact Role',
            nominated_contact_number: 'Nominated Contact Number',
            nominated_contact_email: 'Nominated Contact Email',
            nominated_contact_name: 'Nominated Contact Name',
            status: 'Status',
            crm_id: 'CRM ID',
            crm_url: 'CRM Url',
            agent_number: 'Agent Number',
            enabled: 'Enabled',
            force_3ds: 'Force 3DS',
            partners: 'Partners',
            trading_account_linked: 'Trading Account Linked',
            payment_platforms_linked: 'Payment Platforms Linked',
            contacts_linked: 'Contacts Linked',
            payment_devices_linked: 'Payment Devices Linked',
            id: 'ID',
            type_of_business_lookup: 'Type Of Business',
            quiz_complete: 'Quiz Complete',
            country_lookup: 'Country',
            industry: 'Industry',
            regulated_entity: 'Regulated Entity',
            company_number: 'Company Number',
            lei_number: 'Lei Number',
            license_number: 'License Number',
            annual_income: 'Annual Income',
            regulatory_authority_lookup: 'Regulatory Authority',
            contact_link: 'Contact Link',
            payment_device_type: 'Payment Device Type',
            message: {
                save_success: 'Account has been saved successfully',
            },
            convert_account: {
                title: 'Convert Account',
                approved: 'Approved',
                rejected: 'Rejected',
            },
            website: 'Website',
            website_required: 'Website is required !',
            application: 'Application',
            limit_restriction: 'Min and max deposit limit',
            website_invalid_format: 'Website is invalid format !',
            source_of_dealing_funds_lookup: 'Source of dealing funds',
            trading_experience_lookup: 'Trading experience',
            previous_traded_products_lookup: 'Previous traded products',
            tax_compliance_place_of_birth_lookup: 'Tax compliance place of birth',
            tax_compliance_reason_not_provided_lookup: 'Tax compliance reason not provided',
        },
        contact: {
            message: {
                save_success: 'Contact has been saved successfully.',
                save_prevented: 'Please enter required fields.',
            },
            label: {
                header_create_form: 'Contact Management',
                contact: 'Contact',
                detail: 'Details',
                compliance: 'Compliance',
                account_link: 'Account Link',
                accounts: 'Accounts',
                title: 'Title',
                account_link_place_holder: 'Please enter 3 characters at least to search',
                first_name: 'First Name',
                middle_name: 'Middle Name',
                last_name: 'Last Name',
                role_lookup: 'Role',
                date_of_birth: 'Date Of Birth',
                address: 'Address',
                address_line1: 'Address Line 1',
                address_line2: 'Address Line 2',
                address_city: 'City',
                address_postcode: 'Post Code',
                address_state: 'State',
                address_country_lookup: 'Country',
                address_alt_line1: 'Address Alt Line 1',
                address_alt_line2: 'Address Alt Line 2',
                address_alt_city: 'Alt City',
                address_alt_postcode: 'Alt Post Code',
                address_alt_state: 'Alt State',
                address_alt_country_lookup: 'Alt Country',
                phone_mobile: 'Phone Mobile',
                phone_home: 'Phone Home',
                phone_work: 'Phone Work',
                phone_other: 'Phone Other',
                annual_income_lookup: 'Annual Income',
                country_of_tax_residence_lookup: 'Country Of Tax Residence',
                legal_agreed: 'Legal Agreed',
                legal_agreed_date: 'Legal Agreed Date',
                acknowledge_risks: 'Acknowledge Risks',
                acknowledge_risks_date: 'Acknowledge Risks Date',
                tax_identification_number: 'Tax Identification Number',
                tax_id_exempt_reason_lookup: 'Tax ID Exempt Reason',
                is_current_address: 'Current address',
                address_months: 'Address Months',
                address_years: 'Address Years',
                place_of_birth: 'Place of Birth',
                gender_lookup: 'Gender',
                is_primary: 'Primary',
                email: 'Email',
                accounts_linked: 'Accounts',
                users_linked: 'Users',
                person_account: 'Person Account',
                person_account_tenant: 'Tenant',
                nationality: 'Nationality',
                industry: 'Industry',
                occupation: 'Occupation',
                employment_status: 'Employment Status',
                previous_industry: 'Previous Industry',
                previous_occupation: 'Previous Occupation',
                anticipated_initial_deposit: 'Anticipated Initial Deposit',
                investment_objective: 'Investment Objective',
                liquid_net_worth: 'Liquid Net Worth',
                source_of_funds: 'Source of Funds',
                other_source_of_funds: 'Other Source of Funds',
                referral_description: 'Referral Description',
                secondary_email: 'Secondary Email',
                suppress_transactional_email: 'Suppress Transactional Email',
                fax: 'Fax',
                estimated_net_worth: 'Estimated Net Worth',
                years_experience: 'Years Experience',
                opted_out_email: 'Opted Out Email',
                opted_out_fax: 'Opted Out Fax',
                opted_out_sms: 'Opted Out SMS',
                assessment_result: 'Assessment Result',
                GDPR: 'GDPR',
                created_date: 'Register Date',
                register_ip: 'Register ip',
                register_date: 'Register date',
                do_not_call: 'Do not call',
                crm_id: 'Crm id',
                crm_url: 'Crm url',
                skrill_customer_id: 'Skrill customer id',
                quiz_completed: 'Quiz completed',
                quiz_completed_date: 'Quiz completed date',
                opt_in_agreed_date: 'Opt in agreed date',
                tax_identification_number_type_lookup: 'Tax identification number type',
                ib_remuneration_agreement_accepted: 'Ib remuneration agreement accepted',
                ib_remuneration_agreement_accepted_date: 'Ib remuneration agreement accepted date',
                is_mailing_address: 'Is mailing address',
                is_shipping_address: 'Is shipping address',
                is_other_address: 'Is other address',
                time_at_current_address_lookup: 'Time at current address',
                source: 'Source',
                utm_medium: 'Utm medium',
                utm_campaign: 'Utm campaign',
                utm_term: 'Utm term',
                utm_content: 'Utm content',
                gclid: 'Gclid',
                fbclid: 'Fbclid',
            },
        },
        user: {
            message: {
                change_password: 'Are you sure to change password?',
                change_password_success: 'Password was changed successfull.',
                change_password_and_send_email: 'Are you sure to change password and send email?',
                change_password_and_send_email_success: 'Password was changed successfull and email was sent to {{ email }}'
            },
            label: {
                user: 'User',
                user_create: 'User create',
                user_update: 'User update',
                user_detail: 'User Detail',
                accounts: 'Accounts',
                first_name: 'First Name',
                last_name: 'Last Name',
                telephone_primary: 'Telephone Primary',
                is_send_email: 'Is send email',
                country: 'Country',
                last_login: 'Last Login'
            },
            upgrade: {
                status: {
                    PENDING: 'Pending',
                    APPROVED: 'Approved',
                    REJECTED: 'Rejected'
                }
            }
        },
        trading_account: {
            message: {
                create_success: 'Trading account will be created after a while.',
                update_success: 'Trading account will be updated after a while.',
                required: 'Trading account is required!',
                no_trading_group_found: 'No group has found for this combination',
                bypass_confirmation: 'Are you sure you want to create this trading account with bypass? This action ' +
                    'cannot be undone.',
                not_available: 'No trading account is available for this account'
            },
            label: {
                trading_account: 'Trading Account',
                create_dialog_title: 'Create Trading Account',
                edit_dialog_title: 'Update Trading Account',
                view_dialog_title: 'Page View Trading Account',
                header_create_form: 'Trading Account Management',
                header_edit_form: 'Trading Account Management',
                platform_lookup: 'Platform',
                account_linked: 'Account',
                trading_account_select: 'Select linked Trading Accounts',
                account_link_place_holder: 'Please enter 3 characters at least to search',
                users: 'Users',
                tenant: 'Tenant',
                currency_lookup: 'Currency',
                trading_group: 'Group',
                is_trading_view: 'TV',
                trading_view: 'Trading View',
                trading_account_type_lookup: 'Type',
                leverage_lookup: 'Leverage',
                auto_leverage: 'Auto Leverage',
                send_reports: 'Send Reports',
                enabled: 'Enable',
                processing_state: 'Processing State',
                processing_state_done: 'Done',
                processing_state_prcs: 'Processing',
                processing_state_fail: 'Fail',
                last_login: 'Login',
                balance: 'Balance',
                archived: 'Archived',
                read_only: 'Read Only',
                last_trade_date: 'Last Trade',
                last_deposit_date: 'Last Deposit',
                transfer_from_disabled: 'Transfer From Disabled',
                transfer_to_disabled: 'Transfer To Disabled',
                receive_rebate_transfers: 'Allow RBT transfer',
                allow_reset_password: 'Allow reset password',
                bypass_server_check: 'Bypass'
            },
            status: {
                CNCL: 'Cancelled',
                NEW: 'Pending',
                PRCD: 'Approved',
                UNCF: 'Unconfirmed',
                PDAP: 'Pending Approval',
                UNKN: 'Unknown'
            },
        },
        trading_account_request: {
            label: {
                edit_dialog_title: 'Edit Trading Account Request',
                view_dialog_title: 'Trading Account Request',
                title: 'Trading Account Request',
                save_and_approve: 'Save and approve'
            },
            message: {
                create_success: 'Trading Account Request will be created after a while.',
                update_success: 'Trading Account Request will be updated after a while.',
            },
        },
        leverage: {
            message: {
                create_success: 'Leverage will be created after a while.',
                update_success: 'Leverage will be updated after a while.',
            },
            label: {
                header_create_form: 'Leverage Management',
                leverage: 'Leverage'
            },
        },
        union_pay_card: {
            label: {
                confirmed_accepted: 'Confirmed',
                confirmed_denied: 'Un-Confirmed',
                payload_status_enabled: 'Enabled',
                payload_status_disabled: 'Disabled',
                title: 'Union Pay Cards'
            },
            listing_table: {
                label: 'Label',
                account: 'Account',
                bank_name: 'Bank Name',
                bank_address: 'Bank Address',
                bank_province: 'Bank Province',
                bank_city: 'Bank City',
                bank_branch: 'Bank Branch',
                card_number: 'Card Number',
                contact_info: 'Contact Info',
                confirmed: 'Confirmed',
                status: 'State',
                created: 'Created',
                load_failed: 'Failed to Load Data',
            },
            create_union_pay: {
                china_number: 'China ID Number',
                bank_union_telephone: 'Bank Telephone',
                payload: 'Payload',
                edit_dialog_title: 'Update Union Pay Card',
                create_dialog_title: 'Create Union Pay Card',
                detail_dialog_title: 'Union Pay Card Detail',
                bank_province: 'Bank Province',
                bank_city: 'Bank City',
                bank_branch: 'Bank Branch',
                union_pay_card: 'Union Pay Cards',
                bank_telephone: 'Bank telephone',
                save_success: 'Union pay card has been created successfully.',
                create_success: 'Union pay card has been created successfully.',
            },
        },
        deposit: {
            label: {
                deposit: 'Deposit',
                conversion_date: 'Conversion Date',
                payment_gateway: 'Gateway',
                payment_gateway01: 'Payment Gateway',
                deposit_amount: 'Amount',
                settlement_amount: 'Settlement Amount',
                repair_header: 'Deposit Management',
                conversion_rate: 'Conversion Rate',
                deposit_fee: 'Deposit Fee',
                detail: 'Detail',
                id: 'ID',
                order_number: 'Order Number',
                status: 'Status',
                add: 'Add Deposit',
                account_details: 'Account Details',
                trading_account: 'Trading Account',
                bank_wire_settlement: 'Bank Wire Settlement',
                currency: 'Currency',
                amount: 'Amount',
                ip_address: 'IP Address',
                country: 'Country'
            },
            message: {
                repair_success: 'Deposit has been repaired successfully.',
                amount_required: 'Amount is required!',
                amount_must_be_number: 'Amount must be a number!',
                trading_account_required: 'Trading account is required!',
                save_success: 'Deposit has been saved successfully.'
            },
        },
        withdrawal: {
            message: {
                create_success: 'Withdrawal will be created after a while.',
                update_success: 'Withdrawal will be updated after a while.',
                payment_device_error: 'Data {{ paymentDeviceType }} is empty !',
                delete_success: 'Withdrawals have been deleted successfully',
                delete_warning: 'These {{ count }} items will be deleted.',
                deny_alert: 'This item will be denied',
                deny_success: 'Withdrawal denied successfully',
                approve_alert: 'This items will be approved!',
                approve_success: 'Withdrawals have been approved successfully!',
                bridger_refund_info: 'Loading from Bridger, aprox. 15 second.',
                max_amount_err: 'Amount should less than Max.',
                min_amount_err: 'Amount should greater than 0.',
                amount_required_err: 'Amount is <strong>required</strong>',
                approval_timeout_alert: 'Please wait about 15 mins to process...',
                device_not_supported: 'This payment device type not support yet.',
                withdraw_per_refund: 'Withdrawal Per Refund : 1 - 10000',
                withdraw_per_payout: 'Withdrawal Per Payout : 1 - 20000',
            },
            label: {
                amount: 'Amount',
                currency: 'Currency',
                completed: 'Completed',
                incomplete: 'Not Completed Yet',
                approved: 'Approved',
                confirmed: 'Confirmed',
                inapproved: 'Not Approved Yet',
                paypal: 'Paypal',
                credit_card: 'Credit Card',
                clippay: 'Clippay',
                latin_bank: 'Latin Bank',
                echelon: 'Echelon Pay',
                withdrawal: 'Withdrawal',
                trading_account: 'Trading Account search',
                trading_account_link: 'Trading Account link',
                withdrawal_management: 'Withdrawal Management',
                payment_device_type: 'Payment Device Type',
                crypto: 'Crypto',
                crypto_wallet_address: 'Crypto Wallet Address',
                crypto_number_deposit: 'Number of PMRU|PMRB|PMRT deposits',
                crypto_number_hayvn_deposit: 'Number of HAYVN deposits',
                approve: 'Approve',
                deny: 'Deny',
                device_type: 'Device Type',
                created_date_from: 'From',
                created_date_to: 'To',
                id: 'Reference',
                valid: 'Valid',
                invalid: 'Invalid',
                not_validated_yet: 'Not Validated yet',
                complete: 'Complete',
                not_verified_yet: 'Not Verified yet',
                account_type: 'Account Type',
                account_types: {
                    all: 'All',
                    wallet: 'Wallet'
                },
                reference: 'Reference',
                email: 'Email',
                withdrawal_list: 'Withdrawal List',
                make_withdrawal_page: 'Make Withdrawal Page',
                overview: 'Overview',
                refund: 'Refund',
                withdrawal_overview: 'Withdrawal Overview',
                payout_via_pay_retailers: 'Payout via PayRetailers',
                payout_via_echelon: 'Payout via Echelon',
                payout_via_nab: 'Payout Via Nab',
                payout_via_paymero: 'Payout Via Paymero',
                payout_via_hayvn: 'Payout Via HayVN',
                account_number: 'Account number',
                account_name: 'Account name',
                information: 'Information',
                bank_name: 'Bank name',
                bank_address: 'Bank address',
                bank_branch: 'Bank Branch',
                bank_code: 'Bank Code',
                bank_city: 'Bank City',
                bank_province: 'Bank Province',
                bank_telephone: 'Bank telephone',
                branch_code: 'Branch code',
                swift_code: 'Swift code',
                last_4_digits: 'Last 4 digits',
                iban: 'Iban',
                wallet_id: 'Wallet ID',
                asm_user_id: 'ASM User ID',
                asm_wallet_id: 'ASM Wallet ID',
                account_agency_number: 'Account Agency Number',
                document_type: 'Document Type',
                document_number: 'Document Number',
                customer_first_name: 'Customer First Name',
                customer_last_name: 'Customer Last Name',
                bank_lookup: 'Bank Lookup',
                benificiary_email: 'Beneficiary email',
                benificiary_first_name: 'Beneficiary first name',
                benificiary_last_name: 'Beneficiary last name',
                benificiary_phone: 'Beneficiary phone',
                deposit_amount: 'Deposit Amount',
                remain_balance: 'Remain Balance',
                remaining_withdraw_balance: 'Remaining Withdraw Balance',
                user_first_name: 'User First Name',
                user_email: 'User Email',
                trading_account_reference: 'Trading account reference',
                crypto_number: 'Crypto Number',
                target_currency: 'Target Currency',
                type: 'Type',
                show_refunded: 'Show refunded',
                withdraw_amount: 'Withdraw Amount',
                download_nab_file: 'Download NAB ABA file'
            },
            tooltip: {
                set_to_max: 'Set to Max.',
                refund_via_bridger: 'Refund Via Bridger',
                refund_via_clippay: 'Refund Via Clippay'
            }
        },
        credit_card: {
            label: {
                card_label: 'Card Label',
                type_lookup: 'Type',
                last_4_digits: 'Last Digits',
                expiry_date: 'Expiry Date',
                is_verified_3D_secure: 'Verified 3D Secure',
                is_not_verified_3D_secure: 'Not Verified 3D Secure',
                is_auto_approved: 'Auto Approved',
                is_not_auto_approved: 'Not Auto Approved',
            },
        },
        bank_account: {
            message: {
                save_success: 'Bank Account has been saved successfully.',
            },
            label: {
                bank_account: 'Bank Account',
                name: 'Label',
                account_number: 'Account number',
                bank_name: 'Bank name',
                country: 'Country',
                confirmed: 'Confirmed',
                not_confirmed: 'Not confirmed',
                state: 'State',
            },
        },
        zpay: {
            label: {
                status_captured: 'Captured',
                status_new: 'New',
                status_failed: 'Failed',
            },
        },
        bpay: {
            label: {
                state_captured: 'Captured',
                state_new: 'New',
                state_failed: 'Failed',
            },
        },
        trading_group: {
            label: {
                currency: 'Currency',
                trading_group: 'Trading Group',
                platform: 'Platform',
                tenant: 'Tenant',
                account_type: 'Account Type',
                pricing_type: 'Pricing Type',
                sync_status: 'Sync Status',
                save_and_approve: 'Save and Approve'
            },
            message: {
                approve_alert: 'This trading group will be approved!',
                approve_success: 'Trading group has been approved successfully!'
            }
        },
        poli: {
            message: {
                save_success: 'Poli has been saved successfully.',
            },
            label: {
                poli: "Poli",
                poli_detail: "Poli Detail",
                account: "Account",
                account_link_search: "Account link search",
                account_link: "Account link",
                account_number: "Account number",
                id: "ID",
                email: "Email",
                created: "Created",
                enabled: "Enabled",
                confirmed: "Confirmed",
                state: "State"
            }
        },
        skrill: {
            message: {
                save_success: 'Skrill has been created successfully.',
            },
            label: {
                id: 'ID',
                account: 'Account ID',
                skrill_user: 'Skrill User',
                email: 'Email',
                status: 'Status',
                confirmed: 'Confirmed',
                created: 'Created',
                page_header: 'Skrills',
                enabled: 'Enabled',
                disabled: 'Disabled',
                edit_skrill: 'Edit Skrill',
                create_skrill: 'Create Skrill',
                detail_skrill: 'Skrill Detail',
                un_confirmed: 'Un-confirmed',
            },
        },
        neteller: {
            label: {
                neteller_user: 'Neteller User'
            }
        },
        fasapay: {
            message: {
                save_success: 'Fasapay has been saved successfully.',
            },
            label: {
                fasapay: "Fasapay",
                account: "Account",
                account_link_search: "Account link search",
                account_link: "Account link",
                account_number: "Account number",
                id: "ID",
                email: "Email",
                created: "Created",
                enabled: "Enabled",
                confirmed: "Confirmed",
                state: "State"
            }
        },
        xpaythai: {
            message: {
                save_success: 'The XPay (Thai) has been saved successfully.',
            },
            label: {
                xpaythai: "XPay (Thai)",
                acc_holder_name: "Account holder name",
                bank_account: "Bank Account",
                bank_account_number: "Bank account number",
                bank_province: "Bank province",
                bank_city: "Bank city",
                bank_address: "Bank address",
                bank_telephone: "Bank telephone",
                branch_code: "Branch code",
                swift_code: "Swift code",
                payload_type: "Payload type",
                iban: "Iban"
            }
        },
        gateway: {
            message: {
                create_success: 'Gateway will be created after a while.',
                update_success: 'Gateway will be updated after a while.',
                delete_success: 'Gateway will be deleted after a while.',
            },
            label: {
                id: 'ID',
                page_header: 'Gateways',
                platform_linked: 'Platform',
                fee: 'Fee',
                create_dialog_title: 'Create Gateway',
                edit_dialog_title: 'Update Gateway',
                header_create_form: 'Gateways Management',
                header_edit_form: 'Gateways Management',
                sandbox: 'Sandbox',
                auto_try: 'Auto',
                notification_enabled: 'Notification Enabled',
                merchant: 'Merchant',
                notification_amount: 'Notification Amount',
                detail_dialog_title: 'Gateway Detail',
                detail_header: 'Details',
                deposit_enabled: 'Deposit Enabled',
                deposit_min_value: 'Deposit Min Value',
                deposit_max_value: 'Deposit Max Value',
                withdrawal_min_value: 'Withdrawal Min Value',
                withdrawal_max_value: 'Withdrawal Max Value',
                withdrawal_enabled: 'Withdrawal Enabled',
                deposit_message_enabled: 'Deposit Message Enabled',
                withdrawal_message_enabled: 'Withdrawal Message Enabled',
                deposit_message_header: 'Deposit Message Header',
                deposit_message_body: 'Deposit Message Body',
                withdrawal_message_header: 'Withdrawal Message Header',
                withdrawal_message_body: 'Withdrawal Message Body',
                deposit_message: 'Deposit Message',
                withdrawal_message: 'Withdrawal Message',
                withdrawal: 'Withdrawal',
                deposit: 'Deposit',
                allow_country: 'Allow countries',
                select_all: 'Select All',
                tenants_linked: 'Tenants',
                additional_info: 'Additional Info'
            },
        },
        platform: {
            message: {
                create_success: 'Platform will be created after a while.',
                update_success: 'Platform will be updated after a while.',
                delete_success: 'Platform will be deleted after a while.',
            },
            label: {
                page_header: 'Platforms',
                friendly_name: 'Friendly Name',
                tenants_linked: 'Tenants',
                id: 'ID',
                create_dialog_title: 'Create Platform',
                edit_dialog_title: 'Update Platform',
                header_create_form: 'Platforms Management',
                header_edit_form: 'Platforms Management',
                detail_dialog_title: 'Platform Detail',
                detail_header: 'Details',
                min_amount: 'Min Amount',
                max_amount: 'Max Amount',
                enabled: 'Enabled',
            },
        },
        reward: {
            message: {
                create_success: 'Reward will be created after a while.',
                update_success: 'Reward will be updated after a while.',
            },
            label: {
                ui_enabled: 'UI Enabled',
                api_enabled: 'API Enabled',
                ui_disabled: 'UI Disabled',
                api_disabled: 'API Disabled',
                reward: 'Reward',
                accounts: 'Accounts',
                account_name: 'Account Name',
                account_number: 'Account Number',
                account_search: 'Account link search',
                search_placeholder: 'Please input as least 3 characters ...',
                account_link: 'Account link',
                email: 'Email',
                reward_information: 'Reward Information',
                account: 'Account',
                allocation: 'Allocation',
                allocation_type: 'Allocation Type',
                balance: 'Balance',
                current_balance: 'Current Balance',
                created: 'Created'
            },
        },
        payout: {
            title: 'Payout List',
            gate_way: 'Gateway',
            reference: 'Reference',
            externalId: 'External ID',
            bankName: 'Bank Name',
            bankCode: 'Bank Code',
            bankBranch: 'Bank Branch',
            bankProvince: 'Bank Province',
            bankCity: 'Bank City',
            accName: 'Acc Name',
            accNumber: 'Acc Number',
            amount: 'Amount',
            currency: 'CURR',
            status01: 'Status',
        },
        payout_sheet: {
            label: {
                xpay_thai_title: 'Download XPay Thai Payout Sheet',
                download_raw_data: 'Download Raw Data',
                current_rate: 'Current Rate'
            }
        },
        transfer: {
            message: {
                save_success: 'Transfer has been created successfully.'
            },
            label: {
                transfer: 'Transfer'
            },
            from_trading_account_reference: 'From Trading Account Reference',
            currency: 'From currency',
            amount: 'From amount',
            to_trading_account: 'To Trading Account Reference',
            to_currency: 'To Currency',
            to_amount: 'To Amount',
            order_number: 'From Order Number',
            to_order_number: 'To Order Number',
            created_date: 'Created',
        },
        partner_config: {
            label: {
                campaign_source: 'Campaign Source',
                platform: 'Platform',
                cxd: 'Cxd',
                tenant: 'Tenant',
                login: 'Login',
                rebate_login: 'Rebate Login',
                rebate_login_platform: 'Rebate Login Platform',
                spread_group_raw_mt4: 'Spread Group Raw MT4',
                spread_group_std_mt4: 'Spread Group Std MT4',
                spread_group_raw_mt5: 'Spread Group Raw MT5',
                spread_group_std_mt5: 'Spread Group Std MT5',
                currency: 'Currency',
                enabled: 'Enabled',
                header_create_form: 'Partner Config',
                account_owner: 'Account Owner',
                header_partner_data: 'Partner Data',
                header_spread_groups: 'Spread Groups',
                create_dialog_title: 'Create Partner Config',
                view_dialog_title: 'View Partner Config',
                edit_dialog_title: 'Edit Partner Config',
                auto_populate_agent_number: 'Auto populate agent number'
            },
            message: {
                create_success: 'Partner config will be created after a while.',
                update_success: 'partner config will be updated after a while.',
                delete_success: 'Partner config deleted successfully.',
                bulk_delete_success: 'Partner configs deleted successfully.',
            },
        },
        licences: {
            label: {
                country_name: 'Country Name',
                company_group: 'Company Group',
                default_license: 'Default Licence',
                page_header: 'Country/Licence Jurisdiction Management',
                asic: 'ASIC',
                vfsc: 'VFSC',
                scb: 'SCB',
                svg: 'SVG',
                fca: 'FCA',
                cysec: 'CYSEC',
                editMode: 'Edit Licences',
                viewMode: 'View Licences'
            },
        },
        promotions: {
            message: {
                save_success: 'Promotion has been saved successfully.',
            },
            label: {
                countries: 'Countries',
                languages: 'Languages',
                image: 'Image',
                promotion: 'Promotion',
                promotion_type: 'Promotion type',
                translation_header_key: 'Translation header key',
                translation_body_key: 'Translation body key',
                translation_action_key: 'Translation action key',
                tenants_linked: 'Tenants',
                from_date: 'From date',
                to_date: 'To date',
                is_always_visible: 'Always visible',
                is_action_visible: 'Action visible',
                is_icon_visible: 'Icon visible',
                priority: 'Priority',
                action_type: 'Action type',
                action_data: 'Action data',
                enabled: 'Enabled',
                ib_accounts: 'IB accounts',
                ib_client_accounts: 'IB\'s client accounts',
                direct_accounts: 'Direct accounts',
                inclusion_emails: 'Inclusion emails',
                exclusion_emails: 'Exclusion emails',
                created_date: 'Created date',
                promotion_information: 'Promotion Information'
            },
        },
        ib: {
            label: {
                referal_dialog_title: 'Referral Accounts for IB Affiliate ID:',
                account_number: 'Account Number',
                linked_user_email: 'Linked User Emails',
                link_more_accounts: 'Link More Accounts',
                ib_clients: 'IB Clients',
                platform_logins: 'Number of Platform Logins',
                default_trading_group: 'Default trading group',
                leverage_restriction: 'Leverage restriction',
                affiliate_id: 'Affiliate ID',
            },
            message: {
                no_linked_accounts: 'No linked accounts',
                link_accounts_success: 'Accounts linked successfully',
                unlink_account_success: 'Account unlinked successfully'
            }
        },
        report: {
            sales: {
                registration_from: 'Registration Date From',
                registration_to: 'Registration Date To',
                account_from: 'First Deposit From',
                account_to: 'First Deposit To',
                account_owner: 'Account Owner',
                direct_clients: 'Direct Clients',
                ib: `IB's Clients`,
            },
        },
        
        lookup: {
            label: {
                title: 'Lookup',
                create: 'Create Lookup',
                update: 'Update Lookup',
                type_required: 'Lookup Type  is required !'
            },
            message: {
                create_success: 'Lookup has been created successfully.',
                update_success: 'Lookup has been updated successfully.'
            }
        },
        
    
    },
};
